import React from 'react';

import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

const DocumentFilters = ({ 
  searchQuery, 
  onSearchChange, 
  selectedSite, 
  onSiteChange, 
  selectedCategory, 
  onCategoryChange,
  selectedStatus,
  onStatusChange,
  onClearFilters,
  sites,
  hasActiveFilters
}) => {
  const { t } = useLanguage();

  const categoryOptions = [
    { value: 'all', label: t('allCategories') },
    { value: 'rams', label: 'H&S Docs' },
    { value: 'insurance', label: t('insurance') },
    { value: 'training', label: t('trainingCertificates') },
    { value: 'plant', label: t('plantCertificates') }
  ];

  const statusOptions = [
    { value: 'all', label: t('allStatus') },
    { value: 'valid', label: t('valid') },
    { value: 'expiring-soon', label: t('expiringSoon30Days') },
    { value: 'expired', label: t('expired') }
  ];

  const siteOptions = [
    { value: 'all', label: t('allSites') },
    ...sites?.map(site => ({ value: site?.id, label: site?.site_name }))
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-elevation-2">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4 mb-4">
        <div className="flex-1">
          <Input
            type="search"
            placeholder={t('searchDocumentsPlaceholder')}
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            className="lg:w-auto"
            title={t('clearAllFilters')}
          >
            {t('clearFilters')}
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Select
          label={t('site')}
          options={siteOptions}
          value={selectedSite}
          onChange={onSiteChange}
        />

        <Select
          label={t('category')}
          options={categoryOptions}
          value={selectedCategory}
          onChange={onCategoryChange}
        />

        <Select
          label={t('status')}
          options={statusOptions}
          value={selectedStatus}
          onChange={onStatusChange}
        />
      </div>
    </div>
  );
};

export default DocumentFilters;